import AddJobContainer from './add_job_container';

const AddJob = AddJobContainer;
export default AddJob;
